import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { MenuItem } from 'App/MainMenu/MenuItem'
import WishlistMenuItem from './WishlistMenuItem'
import yn from 'yn'

class UserProfileSubmenu extends Component {
  constructor (props) {
    super()

    this.state = {
      items: [
        {
          path: '/extract',
          label: 'Extrato',
          order: 1,
          target: '_self'
        },
        {
          path: '/my-orders',
          label: 'Pedidos',
          order: 2,
          target: '_self'
        },
        {
          path: 'https://viagens.webpremios.digital/meus-pedidos',
          label: 'Minhas viagens',
          order: 3,
          campaingId: process.env.REACT_APP_CATALOG_ID
        },
        // {
        //   path: '/checkout/points-purchase',
        //   label: 'Comprar reales',
        //   order: 4,
        //   target: '_self'
        // },
        {
          path: '/scheduling',
          label: 'Resgates recorrentes',
          order: 4,
          target: '_self',
          hide: !yn(process.env.REACT_APP_HAS_SCHEDULING)
        },
        {
          path: '/profile',
          label: 'Informações Pessoais',
          order: 5,
          target: '_self'
        },
        {
          path: '/my-address',
          label: 'Endereço',
          order: 6,
          target: '_self'
        },
        // {
        //   path: process.env.REACT_APP_ONBOARDING_ENDPOINT + props.campaing_Id,
        //   label: 'Verificação em Duas Etapas',
        //   order: 7,
        //   target: '_blank',
        //   campaingId: props.campaing_Id
        // },
        // {
        //   path: yn(process.env.REACT_APP_ALLOW_SECURITY_ACCESS) ? '/security-access' : '/my-account/change-password',
        //   label: yn(process.env.REACT_APP_ALLOW_SECURITY_ACCESS) ? 'Acessos e segurança' : 'Alterar Senha',
        //   order: 8,
        //   target: ' _self'
        // },
        {
          path: '/auth/logout',
          label: 'Sair',
          type: 'logout',
          order: 9,
          target: '_self'
        }
      ]
    }

    this.itemsOrdered = this.state.items.sort(function (a, b) {
      return a.order - b.order
    })
  }
  render () {
    return (
      <div id='profile-list' className='bg-brand-5 profile-submenu radius border border-color-ui-4 pb-0'>
        <div className='row px-0 mx-0 radius'>
          <div className='col-12 px-0'>
            <ul role='menu'>
              <WishlistMenuItem />
              {this.itemsOrdered.map((item, indexItem) => (
                <li className='px-0 py-0' role='menuitem'>
                  <MenuItem
                    key={indexItem}
                    {...item}
                    onBlurLink={this.props.onBlurLink}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

UserProfileSubmenu.propTypes = {
  campaing_Id: PropTypes.string,
  onBlurLink: PropTypes.func
}

const mapStateToProps = ({ oidc }) => {
  return ({
    campaing_Id: oidc.user.profile['custom:campaign_id']
  })
}

export default connect(mapStateToProps)(UserProfileSubmenu)



// WEBPACK FOOTER //
// ./src/App/Header/UserProfile/UserProfileSubmenu/UserProfileSubmenu.js